import React, { memo } from 'react'
import PropTypes from 'prop-types'

import styles from './topic.module.scss'

function Topic(props) {
  const { title } = props
  return (
    <span className={styles.topic}>{title}</span>
  )
}

Topic.defaultProps = {
  title: '',
}

Topic.propTypes = {
  title: PropTypes.string,
}

export default memo(Topic)
